var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[(_vm.showNavBar)?_c('van-nav-bar',{attrs:{"title":_vm.title}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }